import { observer } from 'mobx-react-lite'
import { useChatbotContext } from 'pages/chatbot/context'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField.tsx'

export const PointAIQualify = observer(() => {
  const {
    model: { settings },
  } = useChatbotContext()
  const handleQualifyEnabledChange = (status: boolean) => {
    settings.setQualifyEnabled(status)
  }
  return (
    <AgentSwitchField
      active={settings.qualifyEnabled}
      onChange={handleQualifyEnabledChange}
      title={'AI Qualify'}
      isBeta
    />
  )
})
